import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { BoardHelpService } from '../../match-tracker/tracker-board/board-help.service';
import { PartnerConnectService } from '../../_core/services/partner-connect.service';
import { TimeItemTypeEnum } from '../../_shared/models/csTypes/enums/time_item_type';
import { TimeItem } from '../../_shared/models/csTypes/time_item';
import { Match } from '../../_shared/models/match.model';
import { v4 as uuidv4 } from 'uuid';

@Injectable({
    providedIn: 'root'
})
export class InfringementService {
    private violationUpdate$ = new Subject<Match>();

    constructor(
        private bhs: BoardHelpService,
        private partnerConnectService: PartnerConnectService
    ) { }

    getInfringementTimeItems(match: Match): TimeItem[] {
        const infringementTimeItems: TimeItem[] = match.timeItems.filter(ti => ti.itemType === TimeItemTypeEnum.INFRINGEMENT);
        return infringementTimeItems;
    }

    addContextToInfringement(match: Match, note?: string) {
        return {
            pointNumber: this.bhs.getLastPoint(match)?.pointNumber,
            gameNumber: this.bhs.getLastGame(match)?.gameNumber,
            setNumber: this.bhs.getLastSet(match)?.setNumber,
            scoreStringSide1: this.partnerConnectService.getPartnerScore(match, 1),
            scoreStringSide2: this.partnerConnectService.getPartnerScore(match, 2),
            note: note,
            timestamp: new Date(),
            createdAt: new Date(),
            updatedAt: new Date()
        };
    }

    generateTimeItem(itemValue): TimeItem {
        return {
            itemType: TimeItemTypeEnum.INFRINGEMENT,
            itemValue: itemValue,
            itemDate: new Date(),
            itemId: uuidv4()
        };
    }

    publishUpdateViolations(match: Match) {
        this.violationUpdate$.next(match);
    }

    subscribeUpdateViolations(): Observable<Match> {
        return this.violationUpdate$.asObservable();
    }
}
